import { MatDialog } from '@angular/material/dialog';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { AuthService } from '../../../services/auth/auth.service';
import { LayoutService } from '../../../services/layout.service';
import { RoutingService } from '../../../services/routing/routing.service';
import { StorageService } from '../../../services/storage/storage.service';
import { DetailsService } from '../details.service';
import { SharedService } from '../../../services/shared/shared.service';
import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ItemActionsComponent } from './item-actions.component';

@Component({
  selector: 'ag-item-actions-dropdown',
  templateUrl: 'item-actions-dropdown.component.html',
  styleUrls: ['../details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ItemActionsDropdownComponent extends ItemActionsComponent implements OnChanges {
  constructor(
    protected _storageService: StorageService,
    protected _authService: AuthService,
    protected _routingService: RoutingService,
    protected _analyticsService: AnalyticsService,
    protected _layoutService: LayoutService,
    protected _dialog: MatDialog,
    protected _sharedService: SharedService,
    protected _detailsService: DetailsService,
  ) {
    super(
      _storageService,
      _authService,
      _routingService,
      _analyticsService,
      _layoutService,
      _dialog,
      _sharedService,
      _detailsService,
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }
}
